import "../css/ButtonIcon.css";

export default function ButtonIcon({ onClick, icon, text }) {
  return (
    <button className="button-img-container" onClick={onClick} tabIndex={-1}>
      <span className="icon-circle">
        <img src={icon} loading="lazy" alt="Icon" className="button-img-icon" />
      </span>
      <span className="button-icon-text">{text}</span>
    </button>
  );
}
